// libs
import React, { memo } from "react";
import isEmpty from "lodash/isEmpty";

// styles
import { Anchor, Container, BannerText } from "./styles";

// def
interface IDiscountProps {
    discount: {
        text: string;
        action_url?: string;
    };
    className?: string;
}

// constants
const label = "Offer";

function Discount({ discount, className }: IDiscountProps) {
    const Element = <BannerText dangerouslySetInnerHTML={{ __html: discount.text }} />;

    if (!isEmpty(discount.action_url)) {
        return (
            <Anchor as="a" href={discount.action_url} className={className} aria-label={label}>
                {Element}
            </Anchor>
        );
    } else {
        return <Container className={className}>{Element}</Container>;
    }
}

export default memo(Discount);
